export const baseUrl = `${process.env.REACT_APP_baseUrl}`;    
export const baseUrlLocal = `${process.env.REACT_APP_baseUrlLocal}`
// Asignamos la Url base, permite no tener que ingresar toda la ruta al moemnto de realizar la peticion